import React, { Fragment } from 'react'
import NavBar from './components/NavBar'
import Home from './pages/Home'
import About from './pages/About'
import Footer from './components/Footer'
import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import './scss/main.scss'
import '@fortawesome/fontawesome-free/css/all.min.css'
import Registeration from './pages/Registeration'
import Verify from './pages/Verify'
import Contact from './pages/Contact'

const App = () => {
	return (
		<Fragment>
			<Router>
				<NavBar />
				<Switch>
					<Route path='/' component={Home} exact />
					<Route path='/about' component={About} />
					<Route path='/signup' component={Registeration} />
					<Route path='/verify' >
						<Verify />
					</Route>
					<Route path='/contact' component={Contact} />
				</Switch>
				<footer>
          			<Footer />
        		</footer>
			</Router>
		</Fragment>
	)
}

export default App
